"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const common_1 = require("@bimser/common");
const components_1 = require("@bimser/components");
const DockerActionTypes = tslib_1.__importStar(require("../modules/docker/actionTypes"));
const solution_explorer_1 = require("../plugins/solution-explorer");
const BasePluginWindow_1 = tslib_1.__importDefault(require("./BasePluginWindow"));
/**Sol.Exp üzerinden açılan editor barındıran ve kaydetme vs. gibi işlemlere tabi tutulan windowlar */
class FileWindow extends BasePluginWindow_1.default {
    constructor(id, name, plugin, localStorageKeyPrefix) {
        super(id, name, plugin);
        this.onSaveError = this.onSaveError.bind(this);
        this.onSaveSucces = this.onSaveSucces.bind(this);
        this.loadContent = this.loadContent.bind(this);
        this.onAction = this.onAction.bind(this);
        this.getSaveInfoWrappedPromise = this.getSaveInfoWrappedPromise.bind(this);
        this.remakeContentHash = this.remakeContentHash.bind(this);
        const windowInfo = this.getWindowInfo();
        this.localStorageManager = new common_1.LocalStorageManager({
            windowId: this.id,
            onUpdateWindow: this.updateWindow.bind(this),
            keyPrefix: localStorageKeyPrefix,
            startDataHash: windowInfo.initialContentHash
        });
    }
    loadContent(content, isChildContent) {
        return content;
    }
    onAction(listener) {
        var _a;
        if (listener.type == DockerActionTypes.BEFORE_CLOSE_WINDOW) {
            const payload = listener.data;
            payload.closePromise = new Promise((resolve, reject) => {
                const windowInfo = this.getWindowInfo();
                if (windowInfo === null || windowInfo === void 0 ? void 0 : windowInfo.isModified) {
                    this.showCloseConfirmation()
                        .then(result => {
                        if (result === common_1.MessageBoxButton.Yes) {
                            this.save(resolve, reject);
                        }
                        else if (result === common_1.MessageBoxButton.No) {
                            this.localStorageManager.cleanLocalData();
                            resolve();
                        }
                        else {
                            reject();
                        }
                    })
                        .catch(() => {
                        reject();
                    });
                }
                else {
                    resolve();
                }
            });
        }
        else if (listener.type === solution_explorer_1.ActionTypes.SAVEALL &&
            ((_a = this.getWindowInfo()) === null || _a === void 0 ? void 0 : _a.isModified)) {
            //this.toggleLoadingAnimation(true);
            const payload = listener.data;
            payload.saveInfoList.push(this.getSaveInfoWrappedPromise());
        }
        else if (listener.type === solution_explorer_1.ActionTypes.CLOSE_ALL_FILE &&
            listener.data.closeAllButThis != this.id) {
            this.localStorageManager.cleanLocalData();
            this.plugin.ide.closeWindow(this.id, listener.data ? listener.data.disableCloseBefore : false);
        }
        else if (listener.type === solution_explorer_1.ActionTypes.SAVE && this.isActivityWindow()) {
            //this.toggleLoadingAnimation(true);
            const payload = listener.data;
            payload.saveInfoList.push(this.getSaveInfoWrappedPromise());
        }
        else if (listener.type === solution_explorer_1.ActionTypes.SAVE_THIS_FILE &&
            listener.data.id === this.id) {
            listener.data.awaitPromise = new Promise((resolve, reject) => {
                this.save(resolve, reject);
            });
        }
        return listener;
    }
    isActivityWindow() {
        const info = this.getWindowInfo();
        return info ? info.isActivityWindow : false;
    }
    showCloseConfirmation(title, message) {
        return new Promise(resolve => {
            common_1.MessageBox.show({
                buttons: common_1.MessageBoxButtons.YesNoCancel,
                title: title ? title : components_1.findMessage.get('100590'),
                messageType: common_1.MessageBoxIcon.Confirm,
                width: 'medium',
                content: (0, jsx_runtime_1.jsx)("div", { children: message ? message : components_1.findMessage.get('100591') })
            }).then(result => {
                resolve(result.button.id);
            });
        });
    }
    onSaveSucces(callBack) {
        this.updateWindow({ id: this.id, isModified: false });
        this.localStorageManager.cleanLocalData();
        this.remakeContentHash();
        callBack === null || callBack === void 0 ? void 0 : callBack();
    }
    onSaveError(errorInfo, callBack) {
        callBack === null || callBack === void 0 ? void 0 : callBack();
    }
    save(onSucces, onError) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const saveRequestPayload = this.getSaveInfo(onSucces, onError);
            this.plugin.ide.fireAction({
                type: solution_explorer_1.ActionTypes.FILE_SAVE_REQUEST,
                data: saveRequestPayload instanceof Promise
                    ? yield saveRequestPayload
                    : saveRequestPayload
            });
        });
    }
    /**Ovveride for can save data return json*/
    getSaveData() {
        return '';
    }
    getSaveInfoWrappedPromise() {
        return new Promise((resolve, reject) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                const info = this.getSaveInfo();
                info instanceof Promise ? resolve(yield info) : resolve(info);
            }
            catch (_a) {
                reject();
            }
        }));
    }
    getSaveInfo(onSucces, onError) {
        const saveData = this.getSaveData();
        if (saveData instanceof Promise) {
            return new Promise((res) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                return res({
                    data: yield saveData,
                    onSucces: () => this.onSaveSucces(onSucces),
                    onError: err => this.onSaveError(err, onError),
                    pluginId: this.plugin.id,
                    windowId: this.id,
                    fileInfo: Object.assign({}, this.file.fileInfo)
                });
            }));
        }
        return {
            data: saveData,
            onSucces: () => this.onSaveSucces(onSucces),
            onError: err => this.onSaveError(err, onError),
            pluginId: this.plugin.id,
            windowId: this.id,
            fileInfo: Object.assign({}, this.file.fileInfo)
        };
    }
    remakeContentHash() {
        const state = this.plugin.ide.getStore().getState();
        const plugin = state.plugins.get(this.plugin.id);
        if (plugin) {
            const window = plugin.windows.get(this.id);
            if (window) {
                this.updateWindow({
                    id: this.id,
                    isModified: false,
                    remakeContentHash: window.contentData.toJS
                        ? window.contentData.toJS()
                        : window.contentData
                });
            }
        }
    }
}
exports.default = FileWindow;
//# sourceMappingURL=FileWindow.js.map